var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 661,
    height: 763,
    viewBox: "0 0 661 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.64 712.997C317.643 735.74 242.244 735.74 172.248 712.997C102.251 690.254 41.252 645.935 -2.00807 586.393C-45.2681 526.851 -68.5679 455.141 -68.5679 381.543C-68.5679 307.945 -45.2682 236.235 -2.00811 176.693C41.2519 117.151 102.251 72.832 172.248 50.0889C242.244 27.3457 317.643 27.3457 387.64 50.0889C457.636 72.832 518.635 117.151 561.895 176.693C605.155 236.235 628.455 307.945 628.455 381.543",
    stroke: "#60E1CB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.487 110.821C394.658 122.973 446.514 152.913 485.623 196.348C524.732 239.783 549.087 294.485 555.196 352.612C561.306 410.74 548.856 469.31 519.633 519.927C490.409 570.545 445.91 610.611 392.516 634.384C339.121 658.157 279.571 664.416 222.4 652.264C165.229 640.112 113.373 610.173 74.2638 566.737C35.1545 523.302 10.7998 468.601 4.69035 410.473C-1.41912 352.345 11.0303 293.775 40.2542 243.158",
    stroke: "#60E1CB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.976 534.771C109.618 505.635 87.3138 467.003 78.2608 424.412C69.2078 381.821 73.8706 337.457 91.581 297.679C109.291 257.9 139.14 224.75 176.849 202.979C214.558 181.207 258.192 171.933 301.496 176.484C344.8 181.036 385.552 199.18 417.91 228.315C450.269 257.451 472.573 296.083 481.626 338.674C490.679 381.265 486.016 425.629 468.306 465.407C450.595 505.186 420.747 538.336 383.037 560.107",
    stroke: "#60E1CB",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup56);
export default __webpack_public_path__ + "static/media/Group56.6e093ae52836b59c487bbc70f23dbbe1.svg";
export { ForwardRef as ReactComponent };